import { BigNumber, ethers, providers } from 'ethers';
import {useEffect, useState} from "react";
import { useAccount } from 'wagmi';
import { useEthersAdapter } from '@airdao/ui-library';

const readProvider = new providers.JsonRpcProvider(process.env.REACT_APP_RPC_URL);

const initData = {
  balance: '0', bnBalance: BigNumber.from('0')
}

const useBalance = (tokenAddress: string) => {
  const { address: account, chainId } = useAccount();
  const { provider } = useEthersAdapter();

  const [balance, setBalance] = useState(initData);

  useEffect(() => {
    if (account) {
      updateBalance();
      readProvider.on('block', updateBalance);
    }

    return () => {
      if (!account) return;
      readProvider.removeAllListeners();
    };
  }, [account, tokenAddress, chainId]);

  const updateBalance = async () => {
    if (tokenAddress && account && provider) {
      let result = {...balance};
      try {
        if (tokenAddress === ethers.constants.AddressZero) {
          result.bnBalance = await provider.getBalance(account);
          result.balance = ethers.utils.formatEther(result.bnBalance);
          setBalance(result)
          return;
        }
        const minABI = [
          {
            constant: true,
            inputs: [{ name: '_owner', type: 'address' }],
            name: 'balanceOf',
            outputs: [{ name: 'balance', type: 'uint256' }],
            type: 'function',
          },
        ];
        const contract = new ethers.Contract(tokenAddress, minABI, provider);
        result.bnBalance = await contract.balanceOf(account);
        result.balance = ethers.utils.formatEther(result.bnBalance)
      } catch (error) {
        result = initData;
        console.error(error);
      }
      setBalance(result)
    }
  }

  return balance;
};

export default useBalance;
